/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ConvocationResignationEligibleFormativeAction from './ConvocationResignationEligibleFormativeAction';

/**
 * The ConvocationResignationEligibleAcademicProgram model module.
 * @module model/ConvocationResignationEligibleAcademicProgram
 * @version 1.0.0
 */
class ConvocationResignationEligibleAcademicProgram {
    /**
     * Constructs a new <code>ConvocationResignationEligibleAcademicProgram</code>.
     * @alias module:model/ConvocationResignationEligibleAcademicProgram
     */
    constructor() { 
        
        ConvocationResignationEligibleAcademicProgram.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConvocationResignationEligibleAcademicProgram</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConvocationResignationEligibleAcademicProgram} obj Optional instance to populate.
     * @return {module:model/ConvocationResignationEligibleAcademicProgram} The populated <code>ConvocationResignationEligibleAcademicProgram</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConvocationResignationEligibleAcademicProgram();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('formative_actions')) {
                obj['formative_actions'] = ApiClient.convertToType(data['formative_actions'], [ConvocationResignationEligibleFormativeAction]);
            }
        }
        return obj;
    }


}

/**
 * The academic program id.
 * @member {Number} id
 */
ConvocationResignationEligibleAcademicProgram.prototype['id'] = undefined;

/**
 * The academic program name.
 * @member {String} title
 */
ConvocationResignationEligibleAcademicProgram.prototype['title'] = undefined;

/**
 * @member {Array.<module:model/ConvocationResignationEligibleFormativeAction>} formative_actions
 */
ConvocationResignationEligibleAcademicProgram.prototype['formative_actions'] = undefined;






export default ConvocationResignationEligibleAcademicProgram;

